import { heapService, HeapPropertyValue } from "@shared/services/heap";
import {
  jfrogAnalyticsService,
  AnalyticsPropertyValue,
} from "@shared/services/jfrog-analytics";
import { UserDTO } from "@shared/types/common";
import { EventData } from "@jfrog/jfrog-analytics";

export type { AnalyticsPropertyValue };

type AnalyticsService = {
  init: () => void;
  clearAll: () => void;
  setSubscriptionProperties: () => void;
  setUserIdentityProperties: () => Promise<void>;
  track: (event: string, properties?: EventData) => void;
  trackLoginSuccess: (user: UserDTO) => void;
  trackLoginFailed: (arg: {
    reason: string;
    details?: Record<string, AnalyticsPropertyValue>;
  }) => void;
  setPartnerProperties: () => void;
  setPartnerSubscriptionsProperties: () => void;
};

export const analyticsService: AnalyticsService = {
  init: () => {
    heapService.init();
    jfrogAnalyticsService.init();
  },

  clearAll: () => {
    heapService.clearAll();
    jfrogAnalyticsService.clearAll();
  },

  setSubscriptionProperties: () => {
    heapService.setSubscriptionProperties();
    jfrogAnalyticsService.setSubscriptionProperties();
  },

  setPartnerSubscriptionsProperties: () => {
    heapService.setPartnerSubscriptionsProperties();
    jfrogAnalyticsService.setPartnerSubscriptionsProperties();
  },

  setPartnerProperties: () => {
    heapService.setPartnerProperties();
    jfrogAnalyticsService.setPartnerProperties();
  },

  setUserIdentityProperties: async () => {
    heapService.setUserIdentityProperties();
    await jfrogAnalyticsService.setUserIdentityProperties();
  },

  track: (event, properties) => {
    heapService.track(
      event.toUpperCase(),
      properties as Record<string, HeapPropertyValue>,
    );
    jfrogAnalyticsService.track(event, properties);
  },

  trackLoginSuccess: (user) => {
    heapService.trackLoginSuccess(user);
    jfrogAnalyticsService.trackLoginSuccess(user);
  },

  trackLoginFailed: ({ reason, details }) => {
    heapService.trackLoginFailed({
      reason,
      details: details as Record<string, HeapPropertyValue> | undefined,
    });
    jfrogAnalyticsService.trackLoginFailed({ reason, details });
  },
};
